import { ReactElement } from "react";
import {
  Card,
  Row,
  Col,
  PageHeader,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { IAseguradoSearch } from "../../../../services/Asegurado";

import "./style.less";

interface TopBarProps {
  description: string;
  title: string;
  results: number;
  filterFeature: boolean;
  handleClose: () => void;
  setAseguradosOrderedBy?: React.Dispatch<
    React.SetStateAction<IAseguradoSearch[]>
  >;
}

const TopBar: React.FC<TopBarProps> = ({
  title,
  description,
  results,
  handleClose,
}) => {
  const getResults = (resultsParam: number): ReactElement => {
    if (resultsParam === 1) {
      return <p>un resultado</p>;
    } else {
      return <p>{resultsParam} resultados</p>;
    }
  };

  return (
    <div className="TopBar">
      <>
        <div className="top-bar-header">
          <PageHeader>
            <h3 className="top-bar-title">{description}</h3>
          </PageHeader>
        </div>
      </>
      {results !== 0 && (
        <Card>
          <Row>
            <Col span={12}>
              <p>
                Búsqueda:{" "}
                <span className="insured-name">
                  {title ? (
                    <>
                      {title}
                      <CloseOutlined
                        onClick={handleClose}
                        style={{ marginLeft: 5 }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </span>
              </p>
            </Col>
            <Col span={12} className="results">
              {getResults(results)}
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default TopBar;
